/*eslint no-unused-vars: [0]*/
/*eslint no-useless-constructor: [0]*/
import React, {Component} from "react";
import {compose} from 'recompose';
import {connect} from "react-redux";
import {fetchCart, fetchProduct, fetchProducts, fetchOrders, fetchProductBundles, fetchProductCategories, closeCartListDrawer, openCartListDrawer, addProductToCart, setQuantity, setSortBy, setSelectedProductCategory, removeProductFromCart} from "../actions";
import {sortBy} from "lodash";

class ShopHOC extends Component {
	constructor(props) {
		super(props);
	}
}

const checkCartProductsCount = (values, partnerPortalSettings) => {
	var count = 0;
	values.orderRows.forEach((orderRow) => {
		if (partnerPortalSettings && partnerPortalSettings.userCanEditOrders) {
			if (orderRow.status === 5) {
				count += 1;
			}
		} else {
			count += 1;
		}
	})
	return count;
}

const reduxStore = compose(
    connect(
        (state) => {
            return {
				products: sortBy(state.shop.products, 'id'),
				productsMeta: state.shop.productsMeta,
				productsLoading: state.shop.productsLoading,
				cart: state.cart,
				shop: state.shop,
				sortBy: state.shop.sortBy,
				event: state.event,
				cartProducts: [...state.cart.products],
				cartOrder: state.cart.order,
				cartLoading: state.cart.loading,
                cartProductsCount: checkCartProductsCount(state.cart.order, state.partnerPortalSettings.partnerPortalSettings),
                totalPrice: [...state.cart.products].reduce((totalPrice, {price}) => {
                    return totalPrice + price;
				}, 0),
				cartTotal: state.cart.order.totalWithTaxRounded,
				cartListDrawerOpened: state.cart.cartListDrawerOpened,
				productCategories: state.shop.productCategories,
				productFilters: state.shop.productFilters,
				selectedProduct: state.shop.selectedProduct,
				selectedProductCategory: state.shop.selectedProductCategory,
				quantityById: state.cart.quantityById,
				orders: state.orders.orders,
				ordersLoading: state.orders.ordersLoading,
				orderRowsMeta: state.orders.orderRowsMeta,
				partnerPortalSettings: state.partnerPortalSettings.partnerPortalSettings
            }
        },
        (dispatch) => {
            return {
				dispatch,
				fetchCart(eventID) {
					return dispatch(fetchCart(eventID))
				},
				fetchProduct(productID) {
					return dispatch(fetchProduct(productID))
				},
				fetchProducts(eventID, productCategoryId) {
					return dispatch(fetchProducts(eventID, productCategoryId))
				},
				fetchProductCategories() {
					return dispatch(fetchProductCategories())
				},
				addProductToCart(product, eventID, partnerPortalSettings) {
					return dispatch(addProductToCart(product, eventID, partnerPortalSettings))
				},
				removeProductFromCart(orderRowID) {
					return dispatch(removeProductFromCart(orderRowID))
				},
				openCartListDrawer() {
                    return dispatch(openCartListDrawer())
                },
                closeCartListDrawer() {
                    return dispatch(closeCartListDrawer())
				},
				setProductQuantity(productID, quantity, orderRowID) {
					return dispatch(setQuantity(productID, quantity, orderRowID));
				},
				setSortBy(value) {
					return dispatch(setSortBy(value));
				},
				setSelectedProductCategory(productCategoryId) {
					return dispatch(setSelectedProductCategory(productCategoryId));
				},
				fetchProductBundles() {
					return dispatch(fetchProductBundles())
				},
				fetchOrders(eventID) {
					return dispatch(fetchOrders(eventID))
				}
            }
        }
    )
);

export default compose(
    reduxStore
)
